import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Text from '../text/Text';

const AlertMessage = ({ action, message, noPadding, severity }) => {
  const { t } = useTranslation();

  return (
    <Alert
      severity={severity}
      action={
        action && (
          <Button
            variant="text"
            onClick={action}
            color="error"
            sx={{ pt: 0.5 }}
          >
            {t('tryAgain', { ns: 'buttons' })}
          </Button>
        )
      }
      sx={{ mt: noPadding ? 0 : 2 }}
    >
      <Text bodyBold>{message}</Text>
    </Alert>
  );
};

AlertMessage.propTypes = {
  action: PropTypes.func,
  message: PropTypes.string.isRequired,
  noPadding: PropTypes.bool,
  severity: PropTypes.string.isRequired,
};

export default AlertMessage;
